import SamsungOrderInvoiceViewModel from 'src/model/modules/samsungOrderInvoiceView.model';
import SamsungOrderInvoiceModel from 'src/model/samsungOrderInvoice.model';
import { IInitialState } from 'src/store/initialState';

export const samsungDataSel = (
  state: IInitialState
): SamsungOrderInvoiceViewModel => state.samsungOrderInvoiceView;
export const orderPortalSel = (
  state: IInitialState
): SamsungOrderInvoiceViewModel => state.samsungOrderInvoiceView;
export const samsungOrderInvoiceFormSel = (state: IInitialState): any =>
  samsungDataSel(state).samsungSearchForm;
export const samsungOrderInvoicesListSel = (state: IInitialState): any[][] =>
  samsungDataSel(state) ? samsungDataSel(state).samsungOrderResultData : [];
export const pageInformationSel = (state: IInitialState): any =>
  samsungDataSel(state).pageInformation;
